import React from 'react';
import lax from 'lax.js';
import { Link } from 'react-router-dom';
import TicketModal from './TicketModal';

class About extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false
        };

        lax.setup();
        document.addEventListener('scroll', function(x) {
            lax.update(window.scrollY);
        }, false);
        lax.update(window.scrollY);
    }

    // This lifecycle method locks the background body scroll
    componentDidUpdate(prevProps, prevState) {
        if (this.state.isModalOpen !== prevState.isModalOpen) {
            if (this.state.isModalOpen) {
                document.body.style.overflow = "hidden"; // Prevents background scroll
            } else {
                document.body.style.overflow = "auto"; // Restores scroll
            }
        }
    }

    componentWillUnmount() {
        document.body.style.overflow = "auto";
    }

    toggleModal = (e) => {
        if (e) e.preventDefault();
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    render() {
        return (
            <section className="about-area bg-image" style={{paddingBottom: "60px"}} id='jash-e-holi'>
                <div className="container">
                    <div className="row h-100 align-items-center">
                        <div className="col-lg-6 order-2 order-lg-1">
                            <div className="about-content">
                                <h2><b>Jashn-E-Holi 4.0:</b> Pune’s Ultimate Holi Bash 2026 - Ravet</h2>
                                <p>Rain Dance | Punjabi Dhol | Organic Colours | Family Section | Kids Play Arena | Food | Music | Dance | Festive Vibe</p>
                                <p>Get ready for the grandest and most colorful holi celebreation in Pune! jashn-E-Holi 4.0 is back, bigger and better than ever, happening on March 3, 2026, at Le-Stone Rest Lounge, Ravet, Pune.</p>
                                 
                                <Link to="#" className="btn btn-secondary" onClick={this.toggleModal}>
                                    Buy Ticket
                                </Link>
                            </div>
                        </div>

                        <div className="col-lg-6 order-1 order-lg-2">
                            <div className="about-image">
                                <img src={require("../../assets/images/holi/holi6.jpg")} className="about-img1" alt="about"  />
                            </div>
                        </div>
                    </div>
                </div>

                {/* MODAL IS CALLED HERE */}
                <TicketModal 
                    isOpen={this.state.isModalOpen} 
                    onClose={this.toggleModal} 
                />
            </section>
        );
    }
}

export default About;